import { Component, OnInit } from '@angular/core';
import {AuthService} from "../services/auth-service";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {AppConfigService} from "../app-config.service";
import { AddressService } from "../services/address.service";
import {AddressFormComponent} from "../address-form/address-form.component";
import {AddBillingService} from "../services/add-billing.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-lista-datos-f',
  templateUrl: './lista-datos-f.component.html',
  styleUrls: ['./lista-datos-f.component.css']
})
export class ListaDatosFComponent implements OnInit {

  isLoggedIn = false;
  addresses: any[] = [];

  display = false;
  billingId: number;
  itu = '';
  amount = 0;
  backgroundMsg = '';
  logoMsg = '';
  colorTexto = '';
  classBtn = '';
  telefono1 = '';
  telefono2 = '';
  emailAtencion = '';
  typeOrder = '1';
  imgTicket = '';
  imgEcommerceTmk = '';
  imgMeli = '';

  formDelete: FormGroup;

  constructor(private authService: AuthService,
              public dialog: MatDialog,
              private router: Router,
              private configService: AppConfigService,
              private serviceAddress: AddressService,
              private addBilling: AddBillingService,
              private formBuilder: FormBuilder,
              private snackBar: MatSnackBar) {

    this.backgroundMsg = this.configService.getConfig().backgroundMsg;
    this.logoMsg = this.configService.getConfig().logoMsg;
    this.colorTexto = this.configService.getConfig().colorTexto;
    this.classBtn = this.configService.getConfig().classBtn;
    this.telefono1 = this.configService.getConfig().telefono1;
    this.telefono2 = this.configService.getConfig().telefono2;
    this.emailAtencion = this.configService.getConfig().emailAtencion;
    this.imgTicket = this.configService.getConfig().imgTicket;
    this.imgEcommerceTmk = this.configService.getConfig().imgEcommerceTmk;
    this.imgMeli = this.configService.getConfig().imgMeli;
  }

  ngOnInit() {

    this.authService.getIsLoggedIn().subscribe((status) => {
      this.isLoggedIn = status;
      if (status === true) {
        this.addBilling.getBillingAddresses().subscribe({
          next: (response) => {
            this.addresses = response.addresses;
          },
          error: (error) => {
            console.log('Error al obtener las direcciones:', error);
          }
        });
      }
    });

    const storedAddresses = localStorage.getItem('addresses');
    if (storedAddresses) {
      this.addresses = JSON.parse(storedAddresses);
    }

  }

  seleccionarDatos(addresses: any) {
    this.serviceAddress.seleccionarDatos(addresses, this.router, this.serviceAddress);
  }

  addAddress() {
    this.serviceAddress.addAddress(() => {
      this.getBillingAddress();
    });
  }

  getBillingAddress() {
    console.log('getBillingAddres()');
    this.addBilling.getBillingAddresses().subscribe({
      next: (response) => {
        console.log('Datos obtenidos', response);
        this.addresses = response.addresses;
      },
      error: (error) => {
        console.log('Error al obtener las direcciones:', error);
      }
    });
  }

  deleteAddress(id: string) {
    this.serviceAddress.deleteAddress(id, this.formBuilder, () => {
      this.getAddresses(); // Forzar actualización de la lista
    });
  }

  getAddresses() {
    this.addBilling.getBillingAddresses().subscribe({
      next: (response) => {
        console.log('Lista de direcciones actualizada', response);
        this.addresses = response.addresses;
      },
      error: (error) => {
        console.log('Error al actualizar la lista de direcciones:', error);
      }
    });
  }

}
